import { Timestamp } from '@britishcouncil/common-core';
import {
  DateRangeFilter,
  SimpleFiltersObjectValues,
  CustomMultiSelectFilter,
  MultiSelectOption,
} from '@britishcouncil/react-admin';
import { OnlineSpeakingMonitoringDto, OnlineSpeakingMonitoringStatus } from 'api';

type OnlineSpeakingMonitoringFiltersDefinition = {
  status: CustomMultiSelectFilter<OnlineSpeakingMonitoringStatus>;
  date: DateRangeFilter;
};

export type OnlineSpeakingMonitoringFiltersValues =
  SimpleFiltersObjectValues<OnlineSpeakingMonitoringFiltersDefinition>;

const STATUS_OPTIONS: MultiSelectOption<OnlineSpeakingMonitoringStatus>[] = [
  { text: 'Current', value: OnlineSpeakingMonitoringStatus.Current, color: 'green' },
  { text: 'Archived', value: OnlineSpeakingMonitoringStatus.Archived, color: 'yellow' },
  { text: 'Deleted', value: OnlineSpeakingMonitoringStatus.Deleted, color: 'red' },
];

export const FILTERS_DEFINITION: OnlineSpeakingMonitoringFiltersDefinition = {
  status: {
    type: 'custom-multiselect',
    label: 'Status',
    options: STATUS_OPTIONS,
    isMain: true,
    dropdownOptions: {
      placeholder: 'Select monitoring status...',
      showAllSelected: true,
      selectedOnTop: true,
      isClearable: true,
    },
  },
  date: {
    isMain: true,
    type: 'daterange',
    label: 'Date range',
    datePickerOptions: {
      placeholder: 'Select monitoring dates...',
      isClearable: true,
    },
  },
};

export const filterMonitorings = (
  monitorings: OnlineSpeakingMonitoringDto[] | undefined,
  filters: OnlineSpeakingMonitoringFiltersValues
) => {
  let filtered = monitorings ?? [];

  // Filter by status
  if (filters.status && filters.status.length > 0) {
    filtered = filtered?.filter((monitoring) => filters.status!.includes(monitoring.status));
  }

  // Filter by date range
  if (filters.date && filters.date.length > 0) {
    const [startDate, endDate] = filters.date;

    if (endDate) {
      // Date range selected
      filtered = filtered.filter((monitoring) => {
        const monitoringDate = Timestamp.parse(monitoring.monitoringDate);
        return monitoringDate >= startDate && monitoringDate <= endDate;
      });
    } else {
      // Only start date selected
      filtered = filtered.filter((monitoring) => {
        const monitoringDate = Timestamp.parse(monitoring.monitoringDate);
        return monitoringDate >= startDate;
      });
    }
  }

  return filtered;
};
